<template>
  <div>
    <div class="flex items-center space-x-4">
      <h2>{{ isEditing ? "Editar" : "Crear" }} Sucursal</h2>
    </div>

    <div
      v-if="!loading"
      class="card mt-2"
    >
      <form @submit.prevent="save">
        <section-header title="Datos de Sucursal" />

        <div class="form-grid">
          <div class="form-field">
            <label for="name">Nombre de sucursal</label>
            <input id="name" type="text" v-model="form.name" />
            <validation-errors :errors="errorFor('name')"></validation-errors>
          </div>

          <div class="form-field">
            <label for="local_delivery_default_price"
              >Precio default de envío</label
            >
            <input
              id="local_delivery_default_price"
              type="number"
              step="any"
              v-model="form.local_delivery_default_price"
            />
            <validation-errors
              :errors="errorFor('local_delivery_default_price')"
            ></validation-errors>
          </div>

          <div class="form-field">
            <label for="local_delivery_max_weight"
              >Peso máximo por envío (opcional)</label
            >
            <input
              id="local_delivery_max_weight"
              type="number"
              step="any"
              v-model="form.local_delivery_max_weight"
            />
            <validation-errors
              :errors="errorFor('local_delivery_max_weight')"
            ></validation-errors>
          </div>

          <div class="form-field">
            <label for="max_distance">Rango de envío local (km)</label>
            <input id="max_distance" type="number" :min="0" v-model="form.max_distance" />
            <validation-errors :errors="errorFor('max_distance')"></validation-errors>
          </div>
        </div>

        <div class="flex items-center mt-6">
          <input
            id="pickup_delivery"
            type="checkbox"
            class="h-5 w-5"
            v-model="form.pickup_delivery"
          />
          <span
            for="pickup_delivery"
            class="ml-2 text-sm font-medium text-content-700"
            >Habilitar recoger en sucursal</span
          >
        </div>

        <section-header title="Dirección" />

        <div class="form-grid">
          <div class="form-field">
            <label for="street">Calle</label>
            <input id="street" type="text" v-model="form.street" />
            <validation-errors :errors="errorFor('street')"></validation-errors>
          </div>

          <div class="form-field">
            <label for="exterior_number">Número exterior</label>
            <input
              id="exterior_number"
              type="text"
              v-model="form.exterior_number"
            />
            <validation-errors
              :errors="errorFor('exterior_number')"
            ></validation-errors>
          </div>

          <div class="form-field">
            <label for="interior_number">Número interior(opcional)</label>
            <input
              id="interior_number"
              type="text"
              v-model="form.interior_number"
            />
            <validation-errors
              :errors="errorFor('interior_number')"
            ></validation-errors>
          </div>

          <div class="form-field">
            <label for="neighborhood">Colonia</label>
            <input id="neighborhood" type="text" v-model="form.neighborhood" />
            <validation-errors
              :errors="errorFor('neighborhood')"
            ></validation-errors>
          </div>

          <div class="form-field">
            <label for="city">Ciudad</label>
            <input id="city" type="text" v-model="form.city" />
            <validation-errors :errors="errorFor('city')"></validation-errors>
          </div>

          <div class="form-field">
            <label for="state_id">Estado</label>
            <custom-input-select
              v-model="form.state_id"
              id="state_id"
              :options="getStateOptions()"
            />
            <validation-errors :errors="errorFor('state_id')"></validation-errors>
          </div>

          <div class="form-field">
            <label for="zip_code">Código postal</label>
            <input id="zip_code" type="text" v-model="form.zip_code" />
            <validation-errors :errors="errorFor('zip_code')"></validation-errors>
          </div>
        </div>

        <primary-button type="submit" class="mt-10 mx-0" :loading="loadingForm"
          >{{ isEditing ? "Guardar" : "Crear" }}
        </primary-button>
      </form>
    </div>

    <div v-else class="flex w-full h-full items-center">
      <loader-icon class="h-10 w-10 text-primary-500 mx-auto"></loader-icon>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import validationErrors from "@/mixins/validationErrors";
import { is422 } from "@/utils/response";
export default {
  name: "Branch Form",

  data() {
    return {
      states: null,
      form: {
        name: "",
        pickup_delivery: true,
        local_delivery_default_price: "",
        local_delivery_max_weight: "",
        street: "",
        exterior_number: "",
        interior_number: "",
        neighborhood: "",
        city: "",
        state_id: "",
        zip_code: "",
        max_distance: "",
        franchise_id: "",
      },
      loading: false,
      loadingForm: false,
      isEditing: false,
    };
  },

  created() {
    this.loadStates();

    if (this.$route.params.id) {
      this.isEditing = true;
      this.loadBranch();
    }

    this.form.franchise_id = this.$route.params.franchiseId;
  },

  mixins: [validationErrors],

  methods: {
    async loadStates() {
      this.loading = true;

      try {
        this.states = await api.resources.getStates();
      } catch (error) {}

      this.loading = false;
    },

    async loadBranch() {
      this.loading = true;

      try {
        let branch = await api.branches.getById(this.$route.params.id);
        branch.street = branch.address.street;
        branch.exterior_number = branch.address.exterior_number;
        branch.interior_number = branch.address.interior_number;
        branch.zip_code = branch.address.zip_code;
        branch.neighborhood = branch.address.neighborhood;
        branch.city = branch.address.city;
        branch.state_id = branch.address.state_id;

        delete branch.address;
        delete branch.local_delivery_ranges;

        this.form = await JSON.parse(JSON.stringify(branch));
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loading = false;
    },

    getStateOptions() {
      const options = [{ value: null, label: "Seleccionar", disabled: false }];

      this.states.forEach((state) => {
        options.push({
          value: state.id,
          label: state.name,
        });
      });

      return options;
    },

    save() {
      if (!this.validateForm()) {
        this.$store.dispatch(
          "errorSnack",
          "Favor de llenar todos los campos correctamente."
        );
        return;
      }

      if (!this.isEditing) {
        this.createBranch();
      } else {
        this.updateBranch();
      }
    },

    validateForm() {
      this.errors = {};

      if (!this.form.name) {
        this.errors["name"] = ["Campo requerido"];
      }

      if (!this.form.local_delivery_default_price) {
        this.errors["local_delivery_default_price"] = ["Campo requerido"];
      }

      if (!this.form.street) {
        this.errors["street"] = ["Campo requerido"];
      }

      if (!this.form.exterior_number) {
        this.errors["exterior_number"] = ["Campo requerido"];
      }

      if (!this.form.exterior_number) {
        this.errors["exterior_number"] = ["Campo requerido"];
      }

      if (!this.form.city) {
        this.errors["city"] = ["Campo requerido"];
      }

      if (!this.form.state_id) {
        this.errors["state_id"] = ["Campo requerido"];
      }

      if (!this.form.zip_code) {
        this.errors["zip_code"] = ["Campo requerido"];
      }

      if (!this.form.max_distance) {
        this.errors["max_distance"] = ["Campo requerido"];
      }

      return Object.keys(this.errors).length === 0;
    },

    async createBranch() {
      this.loadingForm = true;

      try {
        const response = await api.branches.create(this.form);
        this.$store.dispatch("successSnack", response.message);
        this.$store.dispatch("loadUser");
        this.$router.back();
      } catch (error) {
        if (is422(error)) {
          this.errors = error.response && error.response.data.errors;
        }
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loadingForm = false;
    },

    async updateBranch() {
      this.loadingForm = true;

      try {
        const response = await api.branches.update(
          this.$route.params.id,
          this.form
        );
        this.$store.dispatch("successSnack", response.message);
        this.$router.back();
      } catch (error) {
        if (is422(error)) {
          this.errors = error.response && error.response.data.errors;
        }
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loadingForm = false;
    },
  },
};
</script>

<style>
input[type="checkbox"] {
  accent-color: #5E3A9A;
}
</style>